<template>
  <div class="wrap" id="login" @click="doNothing">
    <div class="bindPhone">
      <div class="form-group">
        <label for="mobile"><i class="icon-mobile"></i></label>
        <input type="tel" class="form-control" id="mobile" placeholder="请输入手机号" maxlength="11" v-model="mobile" />
      </div>

      <div class="form-group">
        <label for="captcha"><i class="icon-code"></i></label>
        <input type="tel" class="form-control" maxlength="6" id="captcha" placeholder="请输入短信验证码" v-model="captcha" />
        <div class="btn-send" @click="checkMsg">
          <span v-if="countDownNumber === 60 && !sendLock">立即发送</span>
          <span class="disabled" v-else-if="countDownNumber === 60 && sendLock">立即发送</span>
          <span class="disabled" v-else>{{ countDownNumber }}秒后重新发送</span>
        </div>
      </div>

      <!--<div class="weui-slider-box" v-if="ticket">
        <div id="slider" class="weui-slider">
          <div class="weui-slider__inner">
            <div class="weui-slider__track"></div>
            <div class="weui-slider__handler"></div>
          </div>
        </div>
        <div id="sliderValue" class="weui-slider-box__value"></div>
      </div>-->

      <button class="btn btn-primary" type="button" @click="bind">{{ pageType == 'change' ? '确认更换' : '立即登录' }}</button>
    </div>
  </div>
</template>

<script>
import { buriedPoint } from '@/utils/utils.js'
let timeInter = null
export default {
  name: 'login',
  data () {
    return {
      relevancyCode: '',
      relevancy: '',
      mobile: '', // 手机号
      captcha: '', // 验证码
      ticket: '', // 校验手机有没有发过短信的码
      sendLock: false, // 发送验证码锁定变量
      countDownNumber: 60, // 倒计时
      bindFlag: true, // 防止重复绑定
      isMobile: /^[1][0-9]{10}$/, // 验证手机正则
      pageType: ''
    }
  },
  activated () {
    this.relevancyCode = this.$route.query.relevancyCode
    this.relevancy = this.$route.query.relevancy
    this.pageType = this.$route.query.type ? this.$route.query.type : ''
    this.mobile = '' // 手机号
    this.captcha = '' // 验证码
    this.ticket = '' // 校验手机有没有发过短信的码
    this.sendLock = false // 发送验证码锁定变量
    this.countDownNumber = 60 // 倒计时
    this.bindFlag = true // 防止重复绑定
    timeInter = null // 计时器
    this.wxConfig()
  },
  methods: {
    doNothing () {
      console.log('doNothing')
    },
    getUrlVars () {
      let vars = []
      let hash
      let hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&')
      for (let i = 0; i < hashes.length; i++) {
        hash = hashes[i].split('=')
        vars.push(hash[0])
        vars[hash[0]] = hash[1]
      }
      return vars
    },
    getUrlVar (name) {
      return this.getUrlVars()[name]
    },
    wxConfig () {
      let self = this
      self.$fly
        .request({
          method: 'get',
          url: '/component/wechat/login/get/js/config/stat',
          params: {
            url: window.location.href,
            domain: location.host
          }
        })
        .then(res => {
          if (res.success) {
            self.$wx.config({
              debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
              appId: res.data.appId, // 必填，企业号的唯一标识，此处填写企业号corpid
              timestamp: res.data.timestamp, // 必填，生成签名的时间戳
              nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
              signature: res.data.signature, // 必填，签名，见附录1
              jsApiList: ['hideAllNonBaseMenuItem', 'showAllNonBaseMenuItem'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
            })
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    checkMsg () {
      // 点击‘立即发送’,先验证该手机24小时内是否发过短信
      let self = this
      if (!self.isMobile.test(self.mobile)) {
        return self.$weui.toast('手机号格式不正确', {
          duration: 2000,
          className: 'toast_text'
        })
      }
      if (!self.sendLock) {
        // 如果发送按钮没有锁定
        self.sendLock = true // 锁定发送
        self.$fly
          .request({
            method: 'post',
            url: '/component/wechat/login/check/and/send/msg',
            params: {
              mobile: self.mobile,
              ticket: self.ticket
            }
          })
          .then(res => {
            if (res.success) {
              self.ticket = ''
              self.countDown() // 发送验证码倒计时
            } else {
              self.sendLock = false // 解锁发送
              if (res.code === 20003) {
                if (res.data) {
                  self.ticket = res.data
                  self.checkMsg() // 重新发送
                  /* self.$nextTick(() => {
                    self.slider() // 滑块
                  }) */
                } else {
                  self.$weui.toast('ticket缺失，请重试', {
                    duration: 2000,
                    className: 'toast_text'
                  })
                }
              } else {
                self.$weui.toast(res.message, {
                  duration: 2000,
                  className: 'toast_text'
                })
              }
            }
          })
          .catch(err => {
            self.sendLock = false // 解锁发送
            console.log(err)
          })
      }
    },
    countDown () {
      // 倒计时
      let self = this
      self.countDownNumber = 59 // 开始倒计时
      // self.clearTimeInterval()
      timeInter = setInterval(function () {
        if (self.countDownNumber > 1) {
          self.countDownNumber--
        } else {
          self.clearTimeInterval()
        }
      }, 1000)
    },
    clearTimeInterval () {
      let self = this
      self.sendLock = false
      self.countDownNumber = 60
      if (timeInter) {
        clearInterval(timeInter)
        timeInter = null
      }
    },
    registerStarGuset () {
      let self = this
      self.$fly
        .request({
          method: 'post',
          url: '/h5/star/alliance2/star/guest/register/star/guest/info',
          params: {
            sourceType: localStorage.getItem('saleOrgType'),
            sourceNo: localStorage.getItem('saleOrgNo'),
            sourceActivityId: localStorage.getItem('activityId')
          }
        })
        .then(res => {
          if (res.success) {
            localStorage.setItem('IS_CIMEN_STAR_USER', 'TRUE')
            self.$router.back(-1)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    bind () {
      // 立即绑定
      let self = this
      if (!self.isMobile.test(self.mobile)) {
        self.$weui.toast('手机号格式不正确', {
          duration: 2000,
          className: 'toast_text'
        })
      } else if (!self.captcha) {
        self.$weui.toast('请填写短信验证码', {
          duration: 2000,
          className: 'toast_text'
        })
      } else {
        if (self.bindFlag) {
          self.bindFlag = false
          self.unbindingStar()
        }
      }
    },
    /**
     * 星客解绑
     */
    unbindingStar () {
      let self = this
      self.$fly
        .request({
          method: 'post',
          url: '/h5/star/alliance2/unbinding'
        })
        .then(res => {
          if (res.success) {
            self.authenticationApply()
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    authenticationApply () {
      // 申请令牌
      let self = this
      self.$fly
        .request({
          method: 'post',
          url: self.$store.state.linkUrl + '/authentication/h5/apply',
          body: {
            appCode: self.$store.state.appId,
            clientCode: localStorage.getItem('STAR_GUEST_UUID')
          }
        })
        .then(res => {
          if (res.success) {
            localStorage.setItem('STAR_GUEST_TOKEN', res.data.tk)
            self.validateBind()
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    /*
     *   interface -- 绑定
     */
    validateBind () {
      let self = this

      self.$fly
        .request({
          method: 'post',
          url: '/h5/star/alliance2/validate/and/bind/stat',
          params: {
            mobile: self.mobile,
            captcha: self.captcha,
            relevancy: self.relevancy,
            relevancyCode: self.relevancyCode
          }
        })
        .then(res => {
          self.bindFlag = true
          if (self.getUrlVar('studioCode')) {
            buriedPoint('SUBMIT', self.getUrlVar('studioCode'))
          }
          if (res.success) {
            let fromurl = self.getUrlVar('fromurl')
            let relevancy = self.getUrlVar('relevancy')
            let relevancyCode = self.getUrlVar('relevancyCode')
            let mallId = self.getUrlVar('mallId')
            if (relevancy !== undefined && relevancy === 'CERTIFICATION_ACTIVITY') {
              window.location.href = fromurl + '?mallId=' + mallId + '&channelCode=' + relevancyCode + '&shareType=detail'
            } else {
              self.registerStarGuset()
            }
          } else {
            if (res.code === 1099999999) {
              // 该手机号被其他微信绑定，提示换绑
              self.$weui.confirm('该手机号已被其他账号绑定，如果继续，原手机号将自动解绑，是否继续？', {
                title: '提示',
                buttons: [
                  {
                    label: '取消',
                    type: 'default',
                    onClick: function () {
                      console.log('取消')
                    }
                  },
                  {
                    label: '确定',
                    type: 'primary',
                    onClick: function () {
                      self.confirmBind()
                    }
                  }
                ]
              })
            } else if (res.code === 31012) {
              self.$weui.confirm(res.message + '，确认切换账户？', {
                title: '提示',
                buttons: [
                  {
                    label: '取消',
                    type: 'default',
                    onClick: function () {
                      console.log('取消')
                    }
                  },
                  {
                    label: '确定',
                    type: 'primary',
                    onClick: function () {
                      self.confirmBind()
                    }
                  }
                ]
              })
            } else {
              self.$weui.toast(res.message, {
                duration: 2000,
                className: 'toast_text'
              })
            }
          }
        })
        .catch(err => {
          self.bindFlag = true
          console.log(err)
        })
    },
    confirmBind () {
      // 确认换绑
      let self = this
      if (self.bindFlag) {
        self.bindFlag = false
        self.$fly
          .request({
            method: 'post',
            url: '/h5/star/alliance2/rebinding/stat',
            params: {
              sourceType: localStorage.getItem('saleOrgType'),
              sourceNo: localStorage.getItem('saleOrgNo'),
              sourceActivityId: localStorage.getItem('activityId')
            }
          })
          .then(res => {
            self.bindFlag = true
            if (res.success) {
              self.$weui.alert('您的手机号已经更换成功。', {
                title: '提示',
                buttons: [
                  {
                    label: '确定',
                    type: 'primary',
                    onClick: function () {
                      self.registerStarGuset()
                    }
                  }
                ]
              })
            } else {
              self.$weui.toast(res.message, {
                duration: 2000,
                className: 'toast_text'
              })
            }
          })
          .catch(err => {
            self.bindFlag = false
            console.log(err)
          })
      }
    }
    /* slider () { // 滑块
      let self = this
      self.$weui.slider('#slider', {
        step: 10,
        defaultValue: 0,
        onChange: function (percent) {
          console.log(percent)
          if (percent >= 100) {
            self.checkMsg()
          }
        }
      })
    } */
  },
  beforeRouteLeave (to, form, next) {
    this.clearTimeInterval()
    next()
  }
}
</script>

<style scoped>
.wrap {
  position: relative;
  height: 100vh;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.bindPhone {
  padding: 42px 28px;
}
.bindPhone .form-group {
  position: relative;
  padding: 0 40px 0 116px;
  margin-bottom: 34px;
  background: #fff;
  border-radius: 10px;
  -webkit-box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
}
.bindPhone .form-group input {
  width: 100%;
  height: 86px;
  padding: 0;
  border: none;
  background: none;
  font-size: 28px;
  color: #333;
}
.bindPhone .form-group input:focus {
  outline: none;
}
.bindPhone .form-group label {
  position: absolute;
  left: 0;
  top: 20px;
  width: 92px;
  height: 48px;
  border-right: solid 1px #dcdcdc;
}
.bindPhone .form-group label i {
  display: block;
  vertical-align: top;
  margin: 0 auto;
}
.bindPhone .form-group label i.icon-mobile {
  width: 28px;
  height: 48px;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAvCAYAAAD9/drQAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3ppVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDo1ZGZlODk2MC0zZGE3LTRlNGMtOWFjMy04N2JiM2EyMTAwOWQiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6MTNFRTREQ0UyQ0U2MTFFODk2MkRFNjQ3M0JGNUIxOEEiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MTNFRTREQ0QyQ0U2MTFFODk2MkRFNjQ3M0JGNUIxOEEiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNCBXaW5kb3dzIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6MTU2RTI3NkIxNTJDRTgxMUFFQkNFMkFBNTg2RDQyNzUiIHN0UmVmOmRvY3VtZW50SUQ9ImFkb2JlOmRvY2lkOnBob3Rvc2hvcDpiY2IxMzc2Ni0wZWRiLTExZTctOGU4YS05ZmE3ODkyZGJhZTYiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz5AKUqwAAAB50lEQVR42uzYTStEURgH8Htn7tAgUjJJecmKxaQkWVHeFZKyYDPCR7CxtvABvC0sbLCRYqesZEGElJISIiQaI80M18z4n+k/dVw3kTu789SvuXPn3Oc559zZnEfXvkYftEOF9r84hw1Yhbi4ofOHLFiGbjiAY5uHY/BmuecCD3yAAW6IgB/qYRt64FnngDkYgk7OxC6KYdxy7wLWoRVW4B6GwYQjWOPq2sTgBkhAyy+2pNTCx13Jk8ZUQQmvy5k7IFYzAFfcvtEfisQ5Uzl0blecn2Iro7yfCdewB70GZyUKBWAGHjTnop8rMg3pRb7wj/DkYKFGrjS5VHkbMjRnw/XtIt2hCqlCqpAqpAqpQqqQKqQKqUKqkCrkTKFEugoZ0rWHjHTkN5j8HV5hlgfiGA/AhtSLiNgclsWxMVv6bkqHZhE3zOsSiW6hho0HFxPnQw48soCIJuiybO8WuyMxqT0Q5HlYRBgORf9BJJ5ms6JDdDg4sAyqWSxIg3ACu5IRJkyNqeOkU9+boRLm3TzuF8AknMEpZ+SFfWn2USYqZMvAx27JjjTmks8n2FdagCWYSu2/OI1PwBjcQYh9H6/0jsI2LzvBRohueUe5UASLbP2YuuVBP/s6tZa2y18ixG7JJvtByfgUYABsImue9l4PwgAAAABJRU5ErkJggg==)
    no-repeat;
  -webkit-background-size: 100% 100%;
  background-size: 100% 100%;
}
.bindPhone .form-group label i.icon-code {
  width: 32px;
  height: 32px;
  margin-top: 8px;
  background: url(data:image/png;base64,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)
    no-repeat;
  -webkit-background-size: 100% 100%;
  background-size: 100% 100%;
}
.bindPhone .form-group .btn-send {
  position: absolute;
  right: 0;
  top: 0;
  padding: 18px 24px;
}
.bindPhone .form-group .btn-send span {
  display: block;
  padding: 0 10px;
  height: 52px;
  line-height: 52px;
  font-size: 24px;
  border: solid 2px #009d8e;
  color: #009d8e;
  box-sizing: border-box;
  border-radius: 6px;
}
.bindPhone .form-group .btn-send span.disabled {
  color: #ccc;
  border-color: #ccc;
}
.bindPhone .btn {
  width: 100%;
  height: 84px;
  color: #fff;
  font-size: 36px;
  border: none;
  background-color: #009d8e;
  border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/login.vue